import { IdleActionTypes, IdleState } from './Types';

export const SAVE_TOKEN_LAST_USED_TIME: IdleActionTypes = 'SAVE_TOKEN_LAST_USED_TIME';
export const TOKEN_EXPIRED: IdleActionTypes = 'TOKEN_EXPIRED';
export const TOKEN_RENEW: IdleActionTypes = 'TOKEN_RENEW';
export const DEFAULT_TOKEN_LAST_USED_TIME = 0;

export const FIFTY_NINE_TIMEOUT_MILLIS = 59 * 60 * 1000;

export const initialIdleState: IdleState = {
  tokenLastUsedTime: DEFAULT_TOKEN_LAST_USED_TIME,
  expired: false
};



// WEBPACK FOOTER //
// ./src/idle/Constants.tsx